import moment from 'moment';
import messages from '../translation_dashboard';
import { cloneDeep } from 'lodash';

const UNITS = {
  CUSTOM: 'custom',
  DAY: 'day',
  HALF_YEAR: 'half_year',
  MONTH: 'month',
  QUARTER: 'quarter',
  WEEK: 'week',
  YEAR: 'year',
};

const DATE_RANGES = {
  today: {
    id: 'today',
    unit: UNITS.DAY,
    value: 0,
  },
  yesterday: {
    id: 'yesterday',
    unit: UNITS.DAY,
    value: -1,
  },
  previous_day: {
    id: 'previous_day',
    unit: UNITS.DAY,
    value: -1,
  },
  two_days_ago: {
    id: 'two_days_ago',
    unit: UNITS.DAY,
    value: -2,
  },
  three_days_ago: {
    id: 'three_days_ago',
    unit: UNITS.DAY,
    value: -3,
  },
  four_days_ago: {
    id: 'four_days_ago',
    unit: UNITS.DAY,
    value: -4,
  },
  five_days_ago: {
    id: 'five_days_ago',
    unit: UNITS.DAY,
    value: -5,
  },
  six_days_ago: {
    id: 'six_days_ago',
    unit: UNITS.DAY,
    value: -6,
  },
  seven_days_ago: {
    id: 'seven_days_ago',
    unit: UNITS.DAY,
    value: -7,
  },
  today_last_year: {
    id: 'today_last_year',
    unit: UNITS.DAY,
    value: -365,
  },
  today_up_to_now: {
    id: 'today_up_to_now',
    intlId: 'today',
    todate: true,
    unit: UNITS.DAY,
    value: 0,
  },
  yesterday_to_date: {
    id: 'yesterday_to_date',
    intlId: 'yesterday',
    todate: true,
    unit: UNITS.DAY,
    value: -1,
  },
  two_days_ago_to_date: {
    id: 'two_days_ago_to_date',
    intlId: 'two_days_ago',
    todate: true,
    unit: UNITS.DAY,
    value: -2,
  },
  three_days_ago_to_date: {
    id: 'three_days_ago_to_date',
    intlId: 'three_days_ago',
    todate: true,
    unit: UNITS.DAY,
    value: -3,
  },
  four_days_ago_to_date: {
    id: 'four_days_ago_to_date',
    intlId: 'four_days_ago',
    todate: true,
    unit: UNITS.DAY,
    value: -4,
  },
  five_days_ago_to_date: {
    id: 'five_days_ago_to_date',
    intlId: 'five_days_ago',
    todate: true,
    unit: UNITS.DAY,
    value: -5,
  },
  six_days_ago_to_date: {
    id: 'six_days_ago_to_date',
    intlId: 'six_days_ago',
    todate: true,
    unit: UNITS.DAY,
    value: -6,
  },
  seven_days_ago_to_date: {
    id: 'seven_days_ago_to_date',
    intlId: 'seven_days_ago',
    todate: true,
    unit: UNITS.DAY,
    value: -7,
  },
  this_week: {
    id: 'this_week',
    unit: UNITS.WEEK,
    value: 0,
  },
  previous_week: {
    id: 'previous_week',
    value: -1,
    unit: UNITS.WEEK,
  },
  last_week: {
    id: 'last_week',
    unit: UNITS.WEEK,
    value: -1,
  },
  two_weeks_ago: {
    id: 'two_weeks_ago',
    unit: UNITS.WEEK,
    value: -2,
  },
  three_weeks_ago: {
    id: 'three_weeks_ago',
    unit: UNITS.WEEK,
    value: -3,
  },
  four_weeks_ago: {
    id: 'four_weeks_ago',
    unit: UNITS.WEEK,
    value: -4,
  },
  this_week_number_last_year: {
    id: 'this_week_number_last_year',
    unit: UNITS.WEEK,
    value: -365,
  },
  this_week_to_date: {
    id: 'this_week_to_date',
    intlId: 'this_week',
    todate: true,
    unit: UNITS.WEEK,
    value: 0,
  },
  last_week_to_date: {
    id: 'last_week_to_date',
    intlId: 'last_week',
    todate: true,
    unit: UNITS.WEEK,
    value: -1,
  },
  two_weeks_ago_to_date: {
    id: 'two_weeks_ago_to_date',
    intlId: 'two_weeks_ago',
    todate: true,
    unit: UNITS.WEEK,
    value: -2,
  },
  three_weeks_ago_to_date: {
    id: 'three_weeks_ago_to_date',
    intlId: 'three_weeks_ago',
    todate: true,
    unit: UNITS.WEEK,
    value: -3,
  },
  four_weeks_ago_to_date: {
    id: 'four_weeks_ago_to_date',
    intlId: 'four_weeks_ago',
    todate: true,
    unit: UNITS.WEEK,
    value: -4,
  },
  this_month: {
    id: 'this_month',
    unit: UNITS.MONTH,
    value: 0,
  },
  previous_month: {
    id: 'previous_month',
    unit: UNITS.MONTH,
    value: -1,
  },
  last_month: {
    id: 'last_month',
    unit: UNITS.MONTH,
    value: -1,
  },
  two_months_ago: {
    id: 'two_months_ago',
    unit: UNITS.MONTH,
    value: -2,
  },
  three_months_ago: {
    id: 'three_months_ago',
    unit: UNITS.MONTH,
    value: -3,
  },
  this_month_last_year: {
    id: 'this_month_last_year',
    unit: UNITS.MONTH,
    value: -365,
  },
  this_month_to_date: {
    id: 'this_month_to_date',
    intlId: 'this_month',
    todate: true,
    unit: UNITS.MONTH,
    value: 0,
  },
  last_month_to_date: {
    id: 'last_month_to_date',
    intlId: 'last_month',
    todate: true,
    unit: UNITS.MONTH,
    value: -1,
  },
  two_months_ago_to_date: {
    id: 'two_months_ago_to_date',
    intlId: 'two_months_ago',
    todate: true,
    unit: UNITS.MONTH,
    value: -2,
  },
  three_months_ago_to_date: {
    id: 'three_months_ago_to_date',
    intlId: 'three_months_ago',
    todate: true,
    unit: UNITS.MONTH,
    value: -3,
  },
  this_quarter: {
    id: 'this_quarter',
    unit: UNITS.QUARTER,
    value: 0,
  },
  previous_quarter: {
    id: 'previous_quarter',
    unit: UNITS.QUARTER,
    value: -1,
  },
  last_quarter: {
    id: 'last_quarter',
    unit: UNITS.QUARTER,
    value: -1,
  },
  two_quarters_ago: {
    id: 'two_quarters_ago',
    unit: UNITS.QUARTER,
    value: -2,
  },
  three_quarters_ago: {
    id: 'three_quarters_ago',
    unit: UNITS.QUARTER,
    value: -3,
  },
  four_quarters_ago: {
    id: 'four_quarters_ago',
    unit: UNITS.QUARTER,
    value: -4,
  },
  this_quarter_to_date: {
    id: 'this_quarter_to_date',
    intlId: 'this_quarter',
    todate: true,
    unit: UNITS.QUARTER,
    value: 0,
  },
  this_year: {
    id: 'this_year',
    unit: UNITS.YEAR,
    value: 0,
  },
  previous_year: {
    id: 'previous_year',
    unit: UNITS.YEAR,
    value: -1,
  },
  last_year: {
    id: 'last_year',
    unit: UNITS.YEAR,
    value: -1,
  },
  this_year_to_date: {
    id: 'this_year_to_date',
    intlId: 'this_year',
    todate: true,
    unit: UNITS.YEAR,
    value: 0,
  },
  this_half_year: {
    id: 'this_half_year',
    unit: UNITS.HALF_YEAR,
    value: 0,
  },
  previous_half_year: {
    id: 'previous_half_year',
    unit: UNITS.HALF_YEAR,
    value: -1,
  },
  last_half_year: {
    id: 'last_half_year',
    unit: UNITS.HALF_YEAR,
    value: -1,
  },
  this_half_year_to_date: {
    id: 'this_half_year_to_date',
    intlId: 'this_half_year',
    todate: true,
    unit: UNITS.HALF_YEAR,
    value: -1,
  },
  custom_date: {
    id: 'custom_date',
    unit: UNITS.CUSTOM,
    value: 0,
  },
};

export const parseDateRange = (id, intl) => {
  const dateRange = cloneDeep(DATE_RANGES[id]);
  const { intlId, todate, unit } = dateRange;

  let suffix = '';

  if (todate) {
    const suffixMsgId = unit === UNITS.DAY ? 'up_to_now' : 'to_date';
    suffix = intl.formatMessage(messages[suffixMsgId]);
  }

  const intlName = intl.formatMessage(messages[intlId || id]);
  const name = `${intlName} ${suffix}`.trim();
  const parsedDateRange = { ...dateRange, name };

  return parsedDateRange;
}

export const getDateRanges = (intl) => {
  const dateRangesValues = Object.values(DATE_RANGES);
  const parsedDateRanges = dateRangesValues.map(({ id }) =>
    parseDateRange(id, intl)
  );

  return parsedDateRanges;
};

export const parseCompareDateRange = (from, to) => {
  const parsedCompareDateRange = {
    from,
    to,
    id: `${from.id}:${to.id}`,
    name: `${from.name} vs ${to.name}`,
  };

  return parsedCompareDateRange;
}

export const getCompareDateRanges = (intl) => {
  const dateRanges = getDateRanges(intl);
  const compareDateRangesMap = new Map();

  for (const fromDateRange of dateRanges) {
    const { id: fromId } = fromDateRange;

    if (fromId === 'custom_date') continue;

    for (const toDateRange of dateRanges) {
      const { id: toId } = toDateRange;

      if (fromId === toId || toId === 'custom_date') continue;

      const cdrMapKey1 = `${fromId}:${toId}`;
      const cdrMapKey2 = `${toId}:${fromId}`;
      const isExisting =
        compareDateRangesMap.get(cdrMapKey1) ||
        compareDateRangesMap.get(cdrMapKey2);

      if (isExisting) continue;

      compareDateRangesMap.set(
        cdrMapKey1,
        parseCompareDateRange(fromDateRange, toDateRange)
      );
    }
  }

  return Array.from(compareDateRangesMap.values());
}

export const getCompareDateRange = (period, ranges, intl) => {
  if (!period) return ranges;

  const [period0, period1] = period.split(':');
  const newDateRanges = cloneDeep(ranges);

  if (period0 !== 'custom_date') {
    const parsedFromRange = parseDateRange(period0, intl);
    const fromRange = getDateRange(parsedFromRange);
    const [fFromDate, fToDate] = fromRange;

    newDateRanges[0] = {
      ...newDateRanges[0],
      from: fFromDate.toISOString(),
      to: fToDate.toISOString(),
      unit: parsedFromRange.unit,
    };
  }

  if (period1 !== 'custom_date') {
    const parsedToRange = parseDateRange(period1, intl);

    const baseDate =
      newDateRanges[0].unit === 'half_year'
        ? newDateRanges[0].from
        : newDateRanges[0].to;

    const toRange = getDateRange(parsedToRange, baseDate);
    const [tFromDate, tToDate] = toRange;

    newDateRanges[1] = {
      ...newDateRanges[1],
      from: tFromDate.toISOString(),
      to: tToDate.toISOString(),
    };
  }

  return newDateRanges;
}

const parseHalfYear = (date, value) => {
  let startMonth = 'january'; 
  let endMonth = 'june';

  const isHalfQuarter = date.quarter() > 2;
  const months = value * 6;

  if (isHalfQuarter) {
    startMonth = 'july';
    endMonth = 'december';
  }

  const dates = [];
  dates[0] = date.clone().month(startMonth).add(months, 'months').startOf('month');
  dates[1] = date.clone().month(endMonth).add(months, 'months').endOf('month');

  return dates;
}

export function getDateRange(dateRangeObj, baseDate) {
  const { unit, value, todate } = dateRangeObj || {};

  const now = moment();
  const date = baseDate ? moment(baseDate) : now;
  const dates = [];

  switch (unit) {
    case UNITS.DAY:
      if (value === -365) {
        dates[0] = date.clone().subtract(1, 'year').startOf('day');
        dates[1] = date.clone().subtract(1, 'year').endOf('day');
      } else {
        dates[0] = date.clone().add(value, 'day').startOf('day');
        dates[1] = date.clone().add(value, 'day').endOf('day');
      }
      break;

    case UNITS.MONTH:
      if (value === -365) {
        dates[0] = date.clone().subtract(1, 'years').startOf('month');
        dates[1] = date.clone().subtract(1, 'years').endOf('month');
      } else {
        dates[0] = date.clone().add(value, 'month').startOf('month');
        dates[1] = date.clone().add(value, 'month').endOf('month');
      }
      break;

    case UNITS.WEEK:
      if (value === -365) {
        dates[0] = date.clone().subtract(1, 'years').startOf('week');
        dates[1] = date.clone().subtract(1, 'years').endOf('week');
      } else {
        dates[0] = date.clone().add(value, 'week').startOf('week');
        dates[1] = date.clone().add(value, 'week').endOf('week');
      }
      break;

    case UNITS.QUARTER:
      dates[0] = date.clone().add(value, 'quarter').startOf('quarter');
      dates[1] = date.clone().add(value, 'quarter').endOf('quarter');
      break;

    case UNITS.QUARTER_RANGE:
      dates[0] = date.clone().add(value, 'quarter').startOf('quarter');
      dates[1] = now;
      break;

    case UNITS.HALF_YEAR:
      const [halfYear0, halfYear1] = parseHalfYear(date, value);
      dates[0] = halfYear0;
      dates[1] = halfYear1;
      break;

    case UNITS.YEAR:
      dates[0] = date.clone().add(value, 'year').startOf('year');
      dates[1] = date.clone().add(value, 'year').endOf('year');
      break;

    default:
      break;
  }

  if (dates[0]) dates[0] = dates[0].toDate();

  if (dates[1]) {
    dates[1] = todate ? now.toDate() : dates[1].toDate();
  }

  return dates;
}
